import type {
  SourcePreparationTerminalReasonCode,
} from '../../source-preparation/source-preparation-types.js';

export const sourcePreparationSyncEntityTypeValues = ['sourcePreparationRequest'] as const;
export type SourcePreparationSyncEntityType =
  (typeof sourcePreparationSyncEntityTypeValues)[number];

export const sourcePreparationSyncEventTypeValues = [
  'sourcePreparationRequestStatusUpdated',
] as const;
export type SourcePreparationSyncEventType =
  (typeof sourcePreparationSyncEventTypeValues)[number];

export interface SourcePreparationRequestStatusUpdatedEventPayload {
  schemaVersion: 1;
  eventId: string;
  occurredAt: string; // ISO datetime
  companyId: string;
  stationId: string;
  requestId: string;
  targetOutboundType: 'SHIPMENT';
  status: 'CANCELED' | 'INVALIDATED';
  reasonCode: SourcePreparationTerminalReasonCode;
}
